<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  created() {
    this.getChainIdMainnetMap();
  },
  methods: {
    async getChainIdMainnetMap() {
      try {
        const response = await fetch(
          `https://aggserver.mytokenpocket.vip/v4/common/liquiditySources`
        );
        const res = await response.json();
        if (res && res.result === 0 && res.data) {
          console.log('res', res.data);
          if (Array.isArray(res.data)) {
            let obj = {};
            res.data.forEach((item) => {
              obj[item.chain] = item.chainId;
            });
            console.log('obj', obj);
            this.$store.commit('setChainIdMainnetMap', obj);
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
